import axios from "axios";
import { createContext, useContext } from "react";
import { serverEnv } from "../env";

const ServerContext = createContext(undefined);

export const ServerProvider = ({children}) => {
    const api = axios.create({
        baseURL: serverEnv.backend,
        withCredentials: true,
    });

    //FUNCTIONS
    const postRequest = (url, data, callback) => {
        api.post(url, data).then((res) => {
            callback([true, res.data]);
        }).catch((res) => {
            callback([false, res]);
        });
    }

    const getRequest = (url, data, callback) => {
        api.get(url, {params: data}).then(res => {
            callback([true, res.data]);
        }).catch((res) => {
            callback([false, res]);
        });
    }

    const value = {
        postRequest,
        getRequest,
    }

    return (
        <ServerContext.Provider value={value}>
            {children}
        </ServerContext.Provider>
    );
}

export const useServer = () => useContext(ServerContext);
